import { EditorActionKey } from "../../../actions/ActionKeys";
import { EditorAction } from "../../../actions/editor";

/** The active open menu path. */
export const activeMenuPath = (state: string[] = [], action: EditorAction) => {
  switch (action.type) {
    case EditorActionKey.SET_EDITOR_MENU:
      return action.payload.menuPath;
    case EditorActionKey.PUSH_EDITOR_MENU:
      return [...state, action.payload.menuName];
    case EditorActionKey.POP_EDITOR_MENU:
      return state.slice(0, -1);
    case EditorActionKey.CLEAR_EDITOR_MENU:
      return [];
    default:
      return state;
  }
};
